<script setup lang='ts'>
const props = defineProps<{
  youtubeVideos: Array<any>;
}>();
</script>

<template>
  <section class="youtube-media normal_spacing" aria-label="YouTube Videos">
    <div v-for="video in props.youtubeVideos" :key="video.id" class="video_item">
      <iframe
        :src="`${video.url}?hl=${video.lang}`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
        :title="video.metadata.title"
      />

      <span>{{ video.metadata.title }}</span>
      <span>{{ video.metadata.thumbnail_url }}</span>
      <meta itemprop="name" :content="video.metadata.title">
      <meta itemprop="thumbnailUrl" :content="video.metadata.thumbnail_url">
    </div>
  </section>
</template>

<style scoped>
.normal_spacing {
  margin-bottom: var(--yb-radius-base);
}

.youtube-media {
  display: flex;
  flex-direction: column;
  gap: var(--yb-spacing-sm);
  margin-block: var(--yb-spacing-2xl);

  iframe {
    width: 100%;
    aspect-ratio: 16/9;
  }

  span {
    display: none;
  }
}

.video_item {
  display: grid;
  border-radius: var(--yb-card-radius);
  overflow: hidden;
}
</style>
